export default "__VITE_ASSET__3b4f48f6__"